export function observable(driver) {
  return new DriverObservable(driver);
}
export class DriverObservable {
  constructor(driver) {
    this.driver = driver;
  }

  postMessage(message) {
    this.driver.postMessage(message);
    const self = this;
    return {
      on(listener) {
        return self.driver.addMessageListener(arrivedMessage => {
          if (arrivedMessage.id === message.id) {
            listener(arrivedMessage);
          }
        });
      }

    };
  }

}